<template>
    <div class="main-content">
        <!-- Page Header Start -->
        <PageHeader>
            <PageHeaderTitleContent>
                <TitleTextContent
                    :titleText="'Cyber Corner'"
                />
                <div class="cyber-corner-header-title mt-2 mt-md-0 mt-lg-0 mt-xl-0">
                    <div class="d-flex justify-content-center align-items-center cyber-corner-title-text mt-3">
                        Welcome to the Cyber Corner where you can learn about the world through the lens of experts in the field
                    </div>
                    <div class="d-flex justify-content-center align-items-center cyber-corner-title-text mt-2 mt-md-5 mt-lg-5 mt-xl-5">
                        Read our news and blogs below
                    </div>
                </div>
            </PageHeaderTitleContent>
        </PageHeader>
        <!-- Page Header End -->

        <!-- Start Cyber Corner Info -->
        <section class="section p-0 mt-5 mb-4 section-content">
            <div class="contain-fluid px-xs-1 px-md-5 px-lg-5 mb-lg-4 mb-xl-4">
                <div class="row m-0">
                    <!-- MOST RECENT BLOG POST START -->
                    <div class="cyber-corner-container col-12 col-md-6 col-lg-6 col-xl-6 py-0 pl-md-0 pl-lg-0 pl-xl-0 d-flex justify-content-center">
                        <div class="cyber-corner-item">
                            <div class="w-100 d-flex justify-content-center section-title">
                                <span>READ OUR NEWEST BLOG</span>
                            </div>

                            <router-link
                                class="cyber-corner-recent-item-image d-flex justify-content-center"
                                :to="{
                                    name: 'blogdetail',
                                    query: {
                                        id: mostRecentBlogPost?.id,
                                        isRecentBlogs: true,
                                    },
                                }"
                            >
                                <div class="item-image-container">
                                    <img 
                                        class="item-image"
                                        :src="mostRecentBlogPost?.mainImage" 
                                        alt=""
                                        width="100%"
                                        height="100%"
                                    >
                                    <div class="item-image-overlay" :style="{ 'backgroundColor': `rgba(0, 0, 0, 0.7)` }">
                                    </div>
                                    <div class="item-title limit-lines-4 mb-3 mb-md-5 mb-lg-5 mb-xl-5">
                                        {{ mostRecentBlogPost?.title }}
                                    </div>
                                </div>
                            </router-link>

                            <div class="w-100 d-flex justify-content-center">
                                <div class="item-headline p-2 limit-lines-5 text-center">
                                {{ mostRecentBlogPost?.headLine }}
                                </div>
                            </div>

                            <div class="row m-0 mt-3">
                                <div class="col-12 p-0 d-flex justify-content-center align-items-center mt-2 mt-md-0 mt-lg-0 mt-xl-0">
                                    <router-link
                                        :to="{
                                            name: 'blog',
                                        }"
                                    >
                                        <v-btn
                                            rounded
                                            large
                                            dark
                                            :color="'#424EC4'"
                                        >
                                            Read All Recent Blogs
                                        </v-btn>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- MOST RECENT BLOG POST END -->

                    <!-- MOST RECENT NEWS POST START -->
                    <div class="cyber-corner-container col-12 col-md-6 col-lg-6 col-xl-6 py-0 pr-md-0 pr-lg-0 pr-xl-0 mt-4 mt-md-0 mt-lg-0 mt-xl-0 d-flex justify-content-center">
                        <div class="cyber-corner-item">
                            <div class="w-100 d-flex justify-content-center section-title">
                                <span>CATCH UP ON RECENT NEWS</span>
                            </div>

                            <router-link
                                class="cyber-corner-recent-item-image d-flex justify-content-center"
                                :to="{
                                    name: 'newsdetail',
                                    query: {
                                        id: mostRecentNewsPost?.id,
                                        isRecentNews: true,
                                    },
                                }"
                            >
                                <div class="item-image-container">
                                    <img 
                                        class="item-image"
                                        :src="mostRecentNewsPost?.article.largeImageURL" 
                                        alt=""
                                        width="100%"
                                        height="100%"
                                    >
                                    <div class="item-image-overlay" :style="{ 'backgroundColor': `rgba(0, 0, 0, 0.7)` }">
                                    </div>
                                    <div class="item-title limit-lines-4 mb-3 mb-md-5 mb-lg-5 mb-xl-5">
                                        {{ mostRecentNewsPost?.article.title }}
                                    </div>
                                </div>
                            </router-link>

                            <div class="w-100 d-flex justify-content-center">
                                <div class="item-headline p-2 limit-lines-5 text-center">
                                    {{ mostRecentNewsPost?.article.headLine }}
                                </div>
                            </div>

                            <div class="row m-0 mt-3">
                                <div class="col-12 p-0 d-flex justify-content-center align-items-center mt-2 mt-md-0 mt-lg-0 mt-xl-0">
                                    <router-link
                                        :to="{
                                            name: 'news',
                                        }"
                                    >
                                        <v-btn
                                            rounded
                                            large
                                            dark
                                            :color="'#424EC4'"
                                        >
                                            Read All Recent News
                                        </v-btn>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- MOST RECENT NEWS POST END -->
                </div>
            </div>
        </section>
        <!-- End Cyber Corner Info -->
    </div>
</template>

<script>
    import axios from 'axios';
    import store from '../store';
    import PageHeader from "./library/widgets/page-header.vue";
    import PageHeaderTitleContent from "./library/widgets/page-header-title-content.vue";
    import TitleTextContent from './library/widgets/title-text-content.vue';
    import { EventBus } from "../utils/eventBus";
    export default {
        data(){
            return {
                mostRecentBlogPost: null,
                mostRecentNewsPost: null,
            };
        },
        components: {
            PageHeader,
            PageHeaderTitleContent,
            TitleTextContent,
        },
        methods: {
            async getBlogItems(){
                try {
                    const response = await axios.get('/api/resources/blogs');
                    const blogItems = response.data.Items.sort((a, b) => new Date(a.date) < new Date(b.date) ? 1 : -1);
                    this.mostRecentBlogPost = blogItems[0];
                    store.commit('setBlogItems', blogItems);
                }
                catch(error) {
                    console.error(error);
                }
            },
            async getNewsItems(){
                try {
                    const response = await axios.get("/api/resources/news");
                    const newsItems = response.data.Items.sort((a, b) => new Date(a.date) < new Date(b.date) ? 1 : -1);
                    this.mostRecentNewsPost = newsItems[0];
                    store.commit('setNewsItems', newsItems);
                }
                catch(error) {
                    console.error(error);
                }
            },
        },
        created(){
            // THIS IS MAKES THE CYBER CORNER MENU TAB THE ACTIVE MENU IN BOTH DESKTOP AND MOBILE
            EventBus.$emit("activate-indicated-menu-item", "Cyber Corner");
        },
        async mounted(){
            await this.getBlogItems();
            await this.getNewsItems();
        }
    }
</script>

<style scoped>
    .cyber-corner-container {
        min-height: 400px;
    }

    .cyber-corner-item {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        width: 100%;
        height: 100%;
    }

    .cyber-corner-header-title {
        color: #fff;
        text-align: center;
        font-family: GeomGraphic;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        font-size: clamp(14px, 2vw, 22px);
        max-width: 50%;
        min-width: 70%;
    }

    .cyber-corner-title-text {
        height: 40px;
    }

    .item-image-container {
        width: 100%;
        max-width: 800px;
        border-radius: 5px;
        overflow: hidden;
        cursor: pointer;
        position: relative;
        max-height: 400px;
        min-height: 200px;
    }

    .cyber-corner-recent-item-image:hover .item-image-container {
        width: 100%;
        -webkit-transform: scale3d(1.05, 1.05, 1.05);
        transform: scale3d(1.05, 1.05, 1.05);
    }

    .item-image {
        width: 100%;
        height: 100%;
        aspect-ratio: 16 / 9; 
        object-fit: cover;
    }

    .item-image-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    .item-title {
        position: absolute;
        bottom: 0;
        width: 55%;
        color: #FFF;
        font-family: GeomGraphic;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        font-size: clamp(18px, 2vw, 28px);
        margin-left: 20px;
    }

    .item-headline {
        max-width: 800px;
        color: #272727;
        font-family: Rajdhani;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        font-size: 18px;
        max-height: 120px;
        margin-top: 10px;
    }
</style>